module.exports = __webpack_public_path__ + "static/media/00_paint_catelin-sainte-genevieve.b1043aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_catelin-sainte-genevieve.jpg
// module id = 276
// module chunks = 0